"use strict";

exports.__esModule = true;
exports["default"] = void 0;

require("core-js/modules/es6.array.index-of");

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.keys");

require("core-js/modules/es6.object.assign");

var _classnames = _interopRequireDefault(require("classnames"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CardLostMissingFilled = function CardLostMissingFilled(_ref) {
  var className = _ref.className,
      style = _ref.style,
      otherProps = _objectWithoutPropertiesLoose(_ref, ["className", "style"]);

  var styleProp = Object.assign({
    verticalAlign: 'middle'
  }, style);
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    className: (0, _classnames["default"])(className),
    viewBox: "0 0 24 24",
    style: styleProp
  }, otherProps), /*#__PURE__*/_react["default"].createElement("g", null, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M20 10.269C19.912 6.243 17.575 2 12.541 2c-7.377 0-7.463 8.41-7.463 8.5 0 4.079-.7 5.009-1.258 5.756a3.639 3.639 0 00-.691 1.274c-.442 1.557.353 2.164.867 2.387a1.935 1.935 0 001.584-.169 1.4 1.4 0 01.538-.172c.209.011.236.012.3.525a1.388 1.388 0 001.01 1.415c.742.168 1.318-.394 1.82-.891.331-.327.718-.687.947-.644.206.047.267.149.389.643a1.552 1.552 0 001.017 1.32c.926.263 1.6-.558 2.134-1.218.175-.216.618-.791.773-.756.117.027.165.106.256.575.094.484.253 1.294 1.184 1.441a1.5 1.5 0 00.242.014 2.056 2.056 0 001.348-.553 6.668 6.668 0 001.745-3.485A1.993 1.993 0 0021 15.991v-4a1.993 1.993 0 00-1-1.722zm-8.948 1.725a1 1 0 011-1h6.958a1 1 0 01.995 1h-8.956zm2.985-5a1 1 0 11-1 1A1 1 0 0114.034 7zm-3.98 0a1 1 0 11-1 1A1 1 0 0110.054 7zm9.951 8.994a1 1 0 01-.995 1h-6.969a.983.983 0 01-.964-.845 5.056 5.056 0 002.671-1.412 1.5 1.5 0 00.362-1.269 1.669 1.669 0 00-.172-.471h6.064z",
    fill: "currentColor"
  })));
};

var _default = CardLostMissingFilled;
exports["default"] = _default;